import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"

const CAD選択 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { planCadDataKbn: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="CAD選択">
      <RadioGroup name={FIELD_NAMES.CAD選択} selectedValue={values.planCadDataKbn} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.CAD選択.CAD指定なし.value}>CAD指定なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択.Altium.value}>Altium</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択["CADLUS ONE（CADLUS Xで編集可能）"].value}>
            CADLUS ONE（CADLUS Xで編集可能）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択["CR5000-BD"].value}>CR5000-BD</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択["CR5000-PWS"].value}>CR5000-PWS</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択.KiCad.value}>KiCad</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択.OrCAD.value}>OrCAD</Radio>
          <Radio value={ESTIMATE_CONSTANT.CAD選択.Quadcept.value}>Quadcept</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.planCadDataKbn} />
    </OneClickField>
  )
}

export default CAD選択
